import React from 'react'
import { Route, Switch } from 'react-router-dom'

import styles from './Admin.module.css'

const AdminIndex = ({ routeName, List, Details, Create, Delete }) => {
  return (
    <div className={styles.container}>
      <Switch>
        <Route path={`/admin/${routeName}`} exact component={List} />} />
        <Route path={`/admin/${routeName}/create`} component={Create} />
        <Route path={`/admin/${routeName}/delete/:id`} component={Delete} />
        <Route path={`/admin/${routeName}/:id`} component={Details} />
      </Switch>
    </div>
  )
}

export default AdminIndex
